import React from 'react';
import ImageBlock from './blocks/ImageBlock';
import VideoBlock from './blocks/VideoBlock';
import HeadingBlock from './blocks/HeadingBlock';
import TextBlock from './blocks/TextBlock';
import ButtonBlock from './blocks/ButtonBlock';
import DividerBlock from './blocks/DividerBlock';
import SpacerBlock from './blocks/SpacerBlock';
import IconTextBlock from './blocks/IconTextBlock';
import FeatureListBlock from './blocks/FeatureListBlock';
import ColumnsBlock from './blocks/ColumnsBlock';
import type { Block } from '../../types';

interface PopupRendererProps {
  blocks: Block[];
}

const PopupRenderer: React.FC<PopupRendererProps> = ({ blocks }) => {
  if (!blocks || blocks.length === 0) return null;

  const renderBlock = (block: Block, index: number) => {
    const { type, content } = block;

    switch (type) {
      case 'image':
        return <ImageBlock key={index} content={content as any} />;
      case 'video':
        return <VideoBlock key={index} content={content as any} />;
      case 'heading':
        return <HeadingBlock key={index} content={content as any} />;
      case 'text':
        return <TextBlock key={index} content={content as any} />;
      case 'button':
        return <ButtonBlock key={index} content={content as any} />;
      case 'divider':
        return <DividerBlock key={index} content={content as any} />;
      case 'spacer':
        return <SpacerBlock key={index} content={content as any} />;
      case 'iconText':
        return <IconTextBlock key={index} content={content as any} />;
      case 'featureList':
        return <FeatureListBlock key={index} content={content as any} />;
      case 'columns':
        return <ColumnsBlock key={index} content={content as any} />;
      default:
        return null;
    }
  };

  return (
    <div className="popup-blocks">
      {blocks.map((block, index) => renderBlock(block, index))}
    </div>
  );
};

export default PopupRenderer;
